import { render, staticRenderFns } from "./CompanyQuestionTwo.vue?vue&type=template&id=a02d3b64&scoped=true&"
import script from "./CompanyQuestionTwo.vue?vue&type=script&lang=js&"
export * from "./CompanyQuestionTwo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyQuestionTwo.vue?vue&type=style&index=0&id=a02d3b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02d3b64",
  null
  
)

export default component.exports